+function($){
	$.fn.slideshow = function(){
		var t = $(this)
        t.currentScreenId = 0
        t.nextScreenId = 0

		//returns screen by ID
		t.getScreen = function(screenId){
			return t.find('.screen-' + screenId)
		}

		//returns current screen
		t.getCurrentScreen = function(){
			return t.getScreen(t.currentScreenId)
		}

		//stores functions which are called when a screen is closing; can return false to prevent this
		t.functionsOnClose = {}

		//stores functions which are called when a screen is showing
		t.functionsOnShow = {}

		//array storing functions which are called when the current screen changes
		var screenChangedFuncs = []

		//add an event handler to screen changed event
		t.onScreenChanged = function(func){
			if (typeof func === 'function'){
				screenChangedFuncs.push(func)
			}
		}

		//helper func to fire screen changed event
		var screenChangedEvent = function(){
			for (var i = 0; i < screenChangedFuncs.length; i++){
				screenChangedFuncs[i]()
			}
		}

		//toggles screens based on ID
		t.toggleScreen = function(nextScreenId, skipOnCloseCb){
            skipOnCloseCb = (typeof skipOnCloseCb !== 'undefined') ? skipOnCloseCb : false

            t.nextScreenId = nextScreenId
			var currentScreen = t.getCurrentScreen()

			if(!skipOnCloseCb) {
                var currentScreenCanClose
                if (typeof t.functionsOnClose[t.currentScreenId] !== 'undefined') {
                    currentScreenCanClose = t.functionsOnClose[t.currentScreenId]()
                }
                if (typeof currentScreenCanClose !== 'undefined' && !currentScreenCanClose) return //screen closing was prevented
            }

			var nextScreen = t.getScreen(nextScreenId)

			if (t.functionsOnShow[nextScreenId]) t.functionsOnShow[nextScreenId]()

			currentScreen.addClass('efi-out')
			nextScreen.removeClass('efi-out')

			t.currentScreenId = nextScreenId

			screenChangedEvent()
		}

		//event fired when clicked on an anchor (calls toggleScreen fx if necessary)
		$('a', t).on('click', function(e){
			var $el = $(this)
			if($el.hasClass('toggle-screen')) t.toggleScreen($el.data('screen'))
			else if($el.parents('.toggle-screen').length > 0) t.toggleScreen($el.parents('.toggle-screen').first().data('screen'))
		})
		return t
	}
}(jQuery)
